import Header from "../../components/Header/Header";
import { observer } from "mobx-react";
//import { ReactComponent as DownArrow } from "../../assets/images/svg/downarrow.svg";
import GoldenDropDown from "../../components/Reports/GoldenDropDown";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ApplyFilter from "../../components/Reports/ApplyFilter";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import nodataImage from "../../assets/images/svg/nodataImage.svg";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
} from "../../components/Accordion/Accordion";
import OverflowingText from "../../components/OverflowingText/OverflowingText";
import EmptyDerivatives from "../../components/EmptyDerivaties/EmptyDerivaties";
import {
  commaSeperated,
  exportExcel,
  getAsOfDate,
  getAllExportData,
  getDecodedToken,
  getDefaultImageOrImage,
  getDisplayDate2,
  getExcelDateDMYUnGL,
  getExcelNumData2,
  getFolioBooleanValue,
  getLimitPerExcel,
  getPrintDate,
  getUnrealisedFolioData,
  lakhAmt,
  logEvents,
  printAllExcelUGL,
  //printDocument,
  trackEventWithScreen,
  unrealisedFolioExcelStyle,
  unrealisedName,
  isNumber,
  getUGLFileName,
} from "../../utils/functions";
//import PopupMenu from "../../components/PopupMenu/PopupMenu";
import ModalFamily from "../../components/ModalFamily/ModalFamily";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import ReportsStore from "../../store/ReportsStore";
import { getCookie } from "../../utils/cookie";
import {
  aquisitionValue,
  exportDataMenuUGLReport,
  REPORTS_PAGE,
  somethingWrongErr,
  somethingWrongErrAll,
  uglAcquisitionError,
  UNREALISED,
  unrealSubAssetDDPosition,
} from "../../utils/constants";
import UnrealisedTable from "../../components/UnrealisedTable/UnrealisedTable";
import UnrealisedFolioTable from "../../components/UnrealisedTable/UnrealisedFolioTable";
import Modal from "../../components/Modal";
import ShowErrorModal from "../../components/ModalFamily/ShowErrorModal";
import AllErrorModalUGL from "../../components/ModalFamily/AllErrorModalUGL";
import PageTitle from "../../components/PageTitle/PageTitle";
import TableCaption from "../../components/TableCaption/TableCaption";
import PageHeading from "../../components/PageHeading/PageHeading";
import ExportReportList from "../../components/AccessibleDropdown/ExportReportList";
import DropdownWithOptions from "../../components/Reports/UnrealisedGLReport/DropdownWithOptions";
import AccountsDropDown from "../../components/Reports/UnrealisedGLReport/AccountsDropDown";
import DateTypeDropdown from "../../components/Reports/UnrealisedGLReport/DateTypeDropdown";

const trasnfArr = [0, 1];
const inceptionArr = [1, 0];

// const ExtractBtn = ({ className = "" }) => {
//   return (
//     <div className={`export_data_btn ${className}`}>
//       <p className="export_data_text">Export Data</p>
//       <div className="export_text_wrapper">
//         <p className="export_type">Excel</p>
//         <DownArrow />
//       </div>
//     </div>
//   );
// };

const AccordionTableHeader = ({
  accordionTableHeaderData,
  handleFilter,
  isAscendingForHeader,
  filteredColumn,
}) => {
  return (
    <thead className="accordion_table_header" style={{ zIndex: 2 }}>
      <tr>
        {accordionTableHeaderData?.map((header) => {
          return (
            <th
              aria-sort={
                filteredColumn === header.key
                  ? isAscendingForHeader
                    ? "Ascending"
                    : "Descending"
                  : undefined
              }
              className="accordion_table_header_child"
              style={{ width: header.width }}
            >
              {header.sortable ? (
                <button
                  onClick={() =>
                    handleFilter(header.key, !isAscendingForHeader)
                  }
                >
                  <p className="accordion_table_header_child_heading blueTextColor">
                    {header.title}
                  </p>
                  {header.sortable && (
                    <div
                      aria-hidden={true}
                      className="accordion_table_header_child_icon"
                      style={{ width: "10px" }}
                    >
                      <img
                        src={
                          filteredColumn === header.key && isAscendingForHeader
                            ? sortedIcon
                            : filteredColumn === header.key &&
                                !isAscendingForHeader
                              ? sortedAtoz
                              : unsortedIcon
                        }
                        alt="sort"
                      />
                    </div>
                  )}
                </button>
              ) : (
                <div>
                  <p className="accordion_table_header_child_heading blueTextColor">
                    {header.title}
                  </p>
                </div>
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

const UnrealisedGainLossReport = observer(() => {
  const [clmSortOrder, setClmSortOrder] = useState([]);
  const [selectedMember, setSelectedMember] = useState(
    ReportsStore.unrealisedReportFilter.selectedMember,
  );
  const [allMembersMenuOpen, setAllMembersMenuOpen] = useState(false);
  const [selectedAccount1, setSelectedAccount1] = useState(
    ReportsStore.unrealisedReportFilter.selectedAccount,
  );
  // const [allAccountsMenuOpen1, setAllAccountsMenuOpen1] = useState(false);
  const [selectedInvestmentType, setSelectedInvestmentType] = useState(
    ReportsStore.unrealisedReportFilter.selectedAssetClass,
  );
  // const [investmentTypeMenuOpen, setInvestmentTypeMenuOpen] = useState(false);
  const [selectedStocks, setSelectedStocks] = useState(undefined);
  //const [stocksMenuOpen, setStocksMenuOpen] = useState(false);
  const [filteredColumn, setFilteredColumn] = useState("instrumentName");
  const [isAscendingForHeader, setIsAscendingForHeader] = useState(true);
  const [openAccordions, setOpenAccordions] = useState({});
  //const [exportMenu, setExportmenu] = useState(false);
  const [isSort, setSort] = useState("asc");
  const [dataForExport, setDataforExport] = useState([]);
  const [clearFilterClicked, setClearFilterClicked] = useState(false);

  const [isFilterClicked, setIsFilterClicked] = useState(false);

  const [sortKeys, setSortKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFolio, setIsFolio] = useState(undefined);
  const [folioData, setFolioData] = useState([]);
  const [folioExportData, setFolioExportData] = useState([]);

  const [downloadPdf, setDownloadPdf] = useState({
    isFetching: false,
    isError: false,
  });

  const [openErrorModel, setOpenErrorModel] = useState(false);
  const [ulGlFilter, setUlGlFilter] = useState({});

  const [allUGlFilter, setAllUGlFilter] = useState({});
  const [allUGLStatus, setAllUGLStatus] = useState({
    isPending: false,
    isError: false,
  });
  const [allUGLError, setAllUGLError] = useState(false);

  const [isInceptionData, setIsInceptionData] = useState({
    isMenunOpen: false,
    defaultValue: "",
    appliedValue: "",
    value: "",
  }); // since inception

  const [errorMsg, setErrorMsg] = useState("");

  function getAccountsList() {
    if (selectedMember === "All") {
      if (ReportsStore?.allAccountsData) {
        return Object?.values(ReportsStore?.allAccountsData)?.flat();
      }
    } else {
      return ReportsStore?.allAccountsData?.[selectedMember?.user_id];
    }
  }

  //const arr = getAccountsList()?.length ? getAccountsList() : ["No Data"];

  //const accounts = ["All", ...arr];

  // const getInitialIndex = () => {
  //   if (selectedAccount1 === "All") return 0;
  //   return accounts.findIndex(
  //     (a) => a.account_Code === selectedAccount1?.account_Code,
  //   );
  // };

  // const [focusedIndex, setFocusedIndex] = useState(getInitialIndex());

  const exportUnrealRef = useRef(null);
  //const ref = useRef(null);
  const controllerRef = useRef(null);
  const controllerRefAll = useRef(null);
  // const listRef = useRef(null);
  const exportItemRefs = useRef([]);

  const onClickOutside = useCallback(() => {
    //setExportmenu(false);
    if (controllerRef.current) controllerRef.current.abort();
    if (controllerRefAll.current) controllerRefAll.current.abort();
  }, []);

  const reportData = ReportsStore.unrealisedReportData;
  const userHydrated = UserStore.isHydrated;
  const unrealisedChecks = ReportsStore.unrealisedChecks;
  const unrealisedFilter = ReportsStore.unrealisedReportFilter;

  const accordionHeaderRender = ({
    type,
    key,
    data,
    className,
    rowData,
    index,
    width,
    handleAccordion,
    openAccordions,
  }) => {
    switch (type) {
      case "button":
        return (
          <td className="accordion_table_data_row_td">
            {Object.values(rowData.subData)?.length > 0 && (
              <div
                className="accordion_down_btn buttonBlueBorder"
                onClick={() => handleAccordion(rowData?.instrumentName, index)}
              >
                <span className="unrealised-gail-loss-btn-animation">
                  {openAccordions[rowData?.instrumentName] ? (
                    <svg
                      width="13"
                      height="8"
                      viewBox="0 0 13 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.05629 2.77309L6.70312 2.42069L6.34996 2.77309L2.11351 7.00031L1.41023 6.29703L6.70312 1.00414L11.996 6.29703L11.2927 7.00031L7.05629 2.77309Z"
                        stroke="#404040"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="13"
                      height="8"
                      viewBox="0 0 13 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.05629 5.23081L6.70312 5.58321L6.34996 5.23081L2.11351 1.0036L1.41023 1.70687L6.70312 6.99977L11.996 1.70688L11.2927 1.0036L7.05629 5.23081Z"
                        stroke="#404040"
                      />
                    </svg>
                  )}
                </span>
              </div>
            )}
          </td>
        );

      case "text":
        return (
          <td
            className={`${className} accordion_table_data_row_td`}
            style={{
              width,
            }}
          >
            <div className="heaader_wrapper_unrealised">
              <p>{data[key] || ""}</p>
            </div>
          </td>
        );

      case "number":
        return (
          <td
            className={`${className} accordion_table_data_row_td`}
            style={{
              width,
            }}
          >
            <div className="heaader_wrapper_unrealised">
              <p>{commaSeperated(data[key]) || ""}</p>
            </div>
          </td>
        );

      default:
        return <p></p>;
    }
  };

  const headerRenderer = ({
    rowData,
    index,
    handleAccordion,
    openAccordions,
  }) => {
    return accordionTableHeaderData?.map(({ renderer, ...rest }) =>
      renderer({
        ...rest,
        rowData,
        index,
        handleAccordion,
        openAccordions,
        data: rowData,
      }),
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        exportUnrealRef.current &&
        !exportUnrealRef.current.contains(event.target)
      ) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  useEffect(() => {
    let arr = [];
    for (let i = 0; i < dataForExport.length; i++)
      if (!(i % 2 === 0)) {
        arr.push(dataForExport[i]);
      }
    setSortKeys(Array(arr.length).fill({ key: "currentValue", isAsc: false }));
  }, [dataForExport]);

  useEffect(() => {
    let dataForExport = [];

    const unrealisedData = ReportsStore.unrealisedReportData;

    if (ReportsStore.unrealisedReportData) {
      // instruments which are of folio type has different logic for displyaing table

      let tempArray = ReportsStore.unrealisedReportData.filter((item) => {
        return item.parentID === "0";
      });

      tempArray.forEach((item) => {
        dataForExport.push({ ...item, primary: true });
        dataForExport.push(
          ReportsStore.unrealisedReportData.filter(
            (itemChild) => itemChild.parentID === item.instrumentID,
          ),
        );
      });

      let instruments = [];

      const selectedSubAssetClass =
        ReportsStore.unrealisedReportFilter.selectedSubAssetClass;

      const isFolioUi = selectedSubAssetClass
        ? selectedSubAssetClass?.isFolio
        : false;

      if (isFolioUi) {
        setIsFolio(true);
        instruments = getUnrealisedFolioData({ unrealisedData });
      } else {
        setIsFolio(false);
        tempArray.forEach((item) => {
          instruments.push({
            ...item,
            primary: true,
            subData: {
              data: ReportsStore.unrealisedReportData.filter(
                (itemChild) =>
                  itemChild.parentID === item.instrumentID &&
                  itemChild.isFolio === "0",
              ),
            },
          });
        });
      }
      setFolioData([...instruments]);
      setFolioExportData([...instruments]);

      if (isFilterClicked) {
        let sortArr = [];
        for (let a = 0; a < tempArray.length; a++) {
          sortArr.push({
            key: "currentValue",
            order: false,
            id: tempArray[a].instrumentID,
          });
        }
        setClmSortOrder(sortArr);
        setIsFilterClicked(false);
      }
    }
    setDataforExport(dataForExport);
  }, [reportData]);

  useEffect(() => {
    const unrealisedGain = UserStore.unrealisedData
      ? JSON.parse(JSON.stringify(UserStore.unrealisedData))
      : UserStore.unrealisedData;

    if (!unrealisedGain?.amount?.actual_value && !unrealisedGain?.percentage) {
      ReportsStore.unrealisedReportFilter = {
        ...ReportsStore.unrealisedReportFilter,
        selectedAssetClass: {
          className: "No Asset Class",
          classID: "noasset",
          nodata: true,
        },
        selectedSubAssetClass: {
          className: "No Sub Asset Class",
          classID: "noasset",
          nodata: true,
        },
      };
      AuthStore.updateLoadingFullScreen(false);
    }
  }, [selectedMember]);

  useEffect(() => {
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    if (UserStore.isHydrated) {
      const value = UserStore.userData
        ? UserStore.usersData !== "(Inception)"
          ? 0
          : 1
        : "";
      setIsInceptionData({
        isMenunOpen: false,
        value,
        defaultValue: value,
        appliedValue: value,
      });
      setLoading(false);
      ReportsStore.populateUnrealisedReportData();
    }

    const resetFilterToDefaultState = () => {
      ReportsStore.unrealisedReportFilter = {
        selectedMember: undefined,
        selectedAssetClass: "All",
        selectedSubAssetClass: "All",
        selectedAccount: "All",
      };
      ReportsStore.unrealisedChecks = {
        memberSuccess: 0,
        accountsSuccess: 0,
        assetClasses: 0,
        subAssetClasses: 0,
      };
    };

    return () => {
      resetFilterToDefaultState();
    };
  }, [userHydrated]);

  useEffect(() => {
    if (
      !Object.values(ReportsStore.unrealisedChecks).filter((e) => !e).length
    ) {
      setUlGlFilter({
        ...ReportsStore.unrealisedReportFilter,
        isFolio:
          ReportsStore.unrealisedReportFilter?.selectedSubAssetClass?.isFolio,
      });
      const { selectedMember, selectedAccount } =
        ReportsStore.unrealisedReportFilter;

      setAllUGlFilter({
        selectedMember,
        selectedAccount,
        subAssetClasses: ReportsStore.subAssetFiltered,
      });

      ReportsStore.updateTableDataLoader(true);
      if (isInceptionData.appliedValue === "") {
        ReportsStore.getUserInceptionType({
          onSuccess: (data) => {
            const reportType = data.processReportType;

            setIsInceptionData((prev) => ({
              ...prev,
              defaultValue: reportType,
              appliedValue: reportType,
              value: reportType,
            }));

            ReportsStore.getUnrealisedReport(reportType);
          },
          onFail: (error) => {
            ReportsStore.updateTableDataLoader(false);
            setErrorMsg(uglAcquisitionError);
            setOpenErrorModel(true);
          },
        });
      } else {
        ReportsStore.getUnrealisedReport(isInceptionData.appliedValue);
      }
    }
    // On First time load or on refresh
  }, [
    unrealisedChecks.accountsSuccess,
    unrealisedChecks.assetClasses,
    unrealisedChecks.subAssetClasses,
    unrealisedChecks.memberSuccess,
  ]);

  useEffect(() => {
    setSelectedInvestmentType(
      ReportsStore.unrealisedReportFilter.selectedAssetClass,
    );

    setSelectedAccount1(ReportsStore.unrealisedReportFilter.selectedAccount);

    setSelectedStocks(
      ReportsStore.unrealisedReportFilter.selectedSubAssetClass,
    );

    isFolio === undefined &&
      setIsFolio(
        ReportsStore.unrealisedReportFilter?.selectedSubAssetClass?.isFolio
          ? true
          : false,
      );
  }, [
    unrealisedFilter.selectedAssetClass,
    unrealisedFilter.selectedSubAssetClass,
  ]);

  useEffect(() => {
    if (clearFilterClicked) {
      setSelectedInvestmentType(
        ReportsStore.unrealisedReportFilter.selectedAssetClass,
      );

      setSelectedAccount1("All");
      setSelectedStocks(
        ReportsStore.unrealisedReportFilter.selectedSubAssetClass,
      );

      setIsFolio(
        ReportsStore.unrealisedReportFilter?.selectedSubAssetClass?.isFolio
          ? true
          : false,
      );
      setClearFilterClicked(false);
    }
  }, [clearFilterClicked]);

  useEffect(() => {
    setSelectedMember(ReportsStore.unrealisedReportFilter.selectedMember);
  }, [
    //  ReportsStore.unrealisedReportFilter.selectedMember
    unrealisedFilter?.selectedMember,
  ]);

  useEffect(() => {
    const subAssetClass =
      ReportsStore.subAssetFiltered[selectedInvestmentType?.classID]?.[0];
    setSelectedStocks(subAssetClass);

    //subAssetClass && setIsFolio(subAssetClass?.isFolio);
  }, [selectedInvestmentType]);

  const onApplyFilter = () => {
    const filter = {
      selectedMember: selectedMember,
      selectedAssetClass: selectedInvestmentType,
      selectedSubAssetClass: selectedStocks, //|| ReportsStore.unrealisedReportFilter.selectedSubAssetClass,
      selectedAccount: selectedAccount1,
    };
    setIsFilterClicked(true);
    setOpenAccordions({});
    ReportsStore.updateUnrealisedFilter(filter);
    setUlGlFilter({ ...filter, isFolio: selectedStocks?.isFolio });

    const { selectedMember: member, selectedAccount } =
      ReportsStore.unrealisedReportFilter;
    setAllUGlFilter({
      selectedMember: member,
      selectedAccount,
      subAssetClasses: ReportsStore.subAssetFiltered,
    });
    setIsFolio(selectedStocks?.isFolio ? true : false);
    ReportsStore.updateTableDataLoader(true);

    setIsInceptionData((prev) => ({
      ...prev,
      appliedValue: prev.value,
    }));

    ReportsStore.getUnrealisedReport(isInceptionData.value, () => {
      setFilteredColumn("instrumentName");
      setIsAscendingForHeader(true);
    });
  };

  const applyDummy = () => {
    setOpenAccordions({});
  };

  const onClearFilter = () => {
    setIsFilterClicked(true);
    const user_type = getDecodedToken()?.user_type;

    // If no persisted value is available from saved data, set the default value to 0 when 'Clear Filter' is clicked
    // And Set the acquisition values to this value and apply filter using this value

    const defaultValue = isInceptionData.defaultValue;
    const value = isNumber(defaultValue) ? defaultValue : 0;

    setIsInceptionData((prev) => ({
      ...prev,
      value,
      appliedValue: value,
    }));

    if (user_type !== "manager") {
      UserStore.getFamilyClients("", (data) => {
        const userId = JSON.parse(getCookie("userid"));
        const primaryClient = data?.filter(
          (el) =>
            el.isprimary === JSON.parse(getCookie("isPrimary")) &&
            (userId ? el.user_id === userId : true),
        )[0];

        ReportsStore.getAssetClassesOfUser(UserStore.userData.user_id, {
          onSuccess: (data) => {
            const filter = {
              selectedMember: primaryClient,
              selectedAssetClass: ReportsStore.allAssetClassesData?.[0],
              selectedSubAssetClass:
                ReportsStore.subAssetFiltered[
                  ReportsStore.allAssetClassesData?.[0]?.classID
                ]?.[0] ||
                ReportsStore.unrealisedReportFilter.selectedSubAssetClass,
              selectedAccount: "All",
            };
            ReportsStore.updateUnrealisedFilter(filter);
            setUlGlFilter({
              ...filter,
              isFolio: filter?.selectedSubAssetClass?.isFolio || 0,
            });
            const { selectedMember: member, selectedAccount: account } =
              ReportsStore.unrealisedReportFilter;
            setAllUGlFilter({
              selectedMember: member,
              selectedAccount: account,
              subAssetClasses: ReportsStore.subAssetFiltered,
            });
            ReportsStore.updateTableDataLoader(true);
            ReportsStore.getUnrealisedReport(value);
          },
        });
      });
    } else {
      const filter = {
        selectedMember: selectedMember,
        selectedAssetClass: ReportsStore.allAssetClassesData?.[0],
        selectedSubAssetClass:
          ReportsStore.subAssetFiltered[
            ReportsStore.allAssetClassesData?.[0]?.classID
          ]?.[0] || ReportsStore.unrealisedReportFilter.selectedSubAssetClass,
        selectedAccount: "All",
      };
      ReportsStore.updateUnrealisedFilter(filter);
      setUlGlFilter({
        ...filter,
        isFolio: filter?.selectedSubAssetClass?.isFolio || 0,
      });
      const { selectedMember: member, selectedAccount: account } =
        ReportsStore.unrealisedReportFilter;
      setAllUGlFilter({
        selectedMember: member,
        selectedAccount: account,
        subAssetClasses: ReportsStore.subAssetFiltered,
      });
      ReportsStore.updateTableDataLoader(true);
      ReportsStore.getUnrealisedReport(value);
    }

    setClearFilterClicked(true);
  };

  const checkAccountsDropdownDisabled = () => {
    return false;
  };

  const AllMembersMenuContent = () => {
    return (
      <ul className="portfolio_report_container">
        <ModalFamily
          unrealised={true}
          setSelectedMemberForReports={(client) => {
            setSelectedMember(client);
            ReportsStore.getAssetClassesOfUser(
              client?.user_id,
              {
                onSuccess: () => {},
              },
              true,
            );
            setAllMembersMenuOpen(false);
            setSelectedAccount1("All");
            ReportsStore.updateUnrealisedFilter({
              ...ReportsStore.unrealisedReportFilter,
              selectedAccount: "All",
            });
          }}
          isSort={isSort}
          setSort={setSort}
          selectedMemberForReports={selectedMember}
          showResetAndSubmit={false}
          searchBarWidth="351px"
        />
      </ul>
    );
  };

  const rowDataForExport = useMemo(() => {
    const output = [];

    const getPrimaryData = ({ item }) => {
      return {
        instrumentName: item.instrumentName || "",
        investmentValue: item.investmentValue || 0,
        currentValue: item.currentValue || 0,
        unrealised_GL: item.unrealised_GL || 0,
      };
    };

    const setFolioData = ({ mainData, subData }) => {
      folioExportData.forEach((item) => {
        // Push the main name

        output.push({
          ...getPrimaryData({ item }),
          ...mainData,
        });

        // Iterate through all keys in subData
        const subArrays = Object.values(item.subData);

        subArrays?.flat()?.forEach((subArray) => {
          output.push(
            subArray.isSecondChild
              ? {
                  ...getPrimaryData({ item: subArray }),
                  primary: subArray.isSecondChild,
                  ...subData,
                }
              : { ...subArray },
          );
        });
      });
    };

    const folioObj = !isFolio
      ? { mainData: { primary: true }, subData: { childata: true } }
      : {
          mainData: {
            mainPrimary: true,
            cellStyles: {
              backgroundColor: "#cca75e",
              fontWeight: 600,
            },
          },
          subData: {
            cellStyles: {
              fontWeight: 600,
            },
          },
        };

    setFolioData(folioObj);

    return output;
    // }
  }, [dataForExport, folioExportData, isFolio]);

  // const ExtractDataContent = () => {
  //   const exportExcelClick = (isFolio) => {
  //     const { selectedMember = null, selectedAccount = null } =
  //       ReportsStore.unrealisedReportFilter;

  //     const excelProps = {
  //       sheetname: "Unrealised Gain Loss Report",
  //       customNameWithTime: unrealisedName(
  //         ReportsStore.unrealisedReportFilter.selectedMember,
  //         ReportsStore.unrealisedReportFilter.selectedAccount,
  //       ),
  //       columns: columnsForExportData,
  //       data: rowDataForExport,
  //       reportDetails: {
  //         relatioshipManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "RM",
  //         )?.name,
  //         serviceManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "CXO",
  //         )?.name,
  //         date: getPrintDate(UserStore.asOfDate),
  //         clientName:
  //           UserStore.getData === "fam"
  //             ? UserStore.userData?.family_name
  //             : UserStore.userData?.full_name,
  //       },
  //       excelName: getUGLFileName({
  //         selectedMember,
  //         selectedAccount,
  //         isInceptionData,
  //       }),
  //     };

  //     exportExcel(
  //       !isFolio
  //         ? excelProps
  //         : {
  //             ...excelProps,
  //             customExcelTableStyle: ({ worksheet, data }) =>
  //               unrealisedFolioExcelStyle({ worksheet, data }),
  //           },
  //     );
  //   };

  //   const getUnrealGLPDFReport = () => {
  //     if (controllerRef.current) controllerRef.current.abort();
  //     const controller = new AbortController();
  //     controllerRef.current = controller;

  //     setDownloadPdf((prev) => ({ isFetching: true, isError: false }));

  //     const {
  //       selectedMember,
  //       selectedAccount,
  //       selectedAssetClass,
  //       selectedSubAssetClass,
  //       isFolio: folio,
  //     } = ulGlFilter;

  //     const getOfficerName = ({ name }) => {
  //       return (
  //         UserStore.exportDetails?.find((item) => item.role === name)?.name ||
  //         ""
  //       );
  //     };

  //     const rmo = getOfficerName({ name: "RM" });
  //     const cxo = getOfficerName({ name: "CXO" });
  //     const name = unrealisedName(selectedMember, selectedAccount);

  //     ReportsStore.getUnrealGLReport({
  //       controller,
  //       fileName: getUGLFileName({
  //         selectedMember,
  //         selectedAccount,
  //         isInceptionData,
  //       }),
  //       params: {
  //         familyCode: "",
  //         clientCode: selectedMember.user_id,
  //         accountCode:
  //           selectedAccount === "All" ? 0 : selectedAccount.account_Code,
  //         classID: selectedAssetClass.classID,
  //         subClassID: selectedSubAssetClass.classID,
  //         client_Info: {
  //           client_Name: name,
  //           account_Name:
  //             selectedAccount === "All" ? "All" : selectedAccount.account_Code,
  //           date: getAsOfDate(UserStore.asOfDate),
  //           relationship_Manager: rmo,
  //           service_Manager: cxo,
  //         },
  //         isFolio: getFolioBooleanValue({ isFolio: folio }),
  //         isInception: isInceptionData.appliedValue,
  //       },
  //       onSuccess: (data) => {
  //         setDownloadPdf((prev) => ({ isFetching: false, isError: false }));
  //         setExportmenu(false);
  //       },
  //       onFail: (err) => {
  //         setDownloadPdf((prev) => ({
  //           isFetching: false,
  //           isError: "Error Downloading the file",
  //         }));
  //         if (err.code !== "ERR_CANCELED") setOpenErrorModel(true);
  //         setExportmenu(false);
  //       },
  //     });
  //   };

  //   return (
  //     <>
  //       <div
  //         ref={ref}
  //         className="extract_data_container downloadAllPdf downloadPdf"
  //       >
  //         <p className="export_data_text">Export Data</p>
  //         <ul className="listitem_container">
  //           <li
  //             onClick={() => {
  //               if (controllerRefAll.current) controllerRefAll.current.abort();
  //               const controllerAll = new AbortController();
  //               controllerRefAll.current = controllerAll;

  //               setAllUGLStatus((prev) => ({
  //                 isPending: true,
  //                 isError: false,
  //               }));
  //               // fetch all records from api ( Record includes folio as well as normal instruments but are not in order )
  //               ReportsStore.getUnrealisedReportAllExcel({
  //                 controllerAll,
  //                 filterData: {
  //                   ...allUGlFilter,
  //                   isInception: isInceptionData.appliedValue,
  //                 },
  //                 onSuccess: (data) => {
  //                   // Using available asset and sub asset class data of selected user , we get folioInstrument, nonFolioInstrument
  //                   // { folioInstrument , nonFolioInstrument } = data
  //                   // those instruments are not in order and also not in their respective group
  //                   // below exportMetaData contains foliodata and nonFolioData in order
  //                   // all the data we display , we get it from the api and from fron-end there is no calculation , only grouping is done.
  //                   // { folioData , nonFolioData } = getAllExportData(data)
  //                   const exportMetaData = getAllExportData(data);

  //                   printAllExcelUGL({
  //                     sheetName: "Unrealised Gain Loss Full Report",
  //                     filter: ReportsStore.unrealisedReportFilter,
  //                     columns: columnsForExportData,
  //                     exportMetaData,
  //                     exportDetails: UserStore.exportDetails,
  //                     asOfDate: UserStore.asOfDate,
  //                     getData: UserStore.getData,
  //                     userData: UserStore.userData,
  //                     isInceptionData,
  //                   });

  //                   setAllUGLStatus((prev) => ({
  //                     isPending: false,
  //                     isError: false,
  //                   }));
  //                   setExportmenu(false);
  //                 },
  //                 onFail: (error) => {
  //                   setAllUGLStatus((prev) => ({
  //                     isPending: false,
  //                     isError: "Error Downloading the file",
  //                   }));
  //                   if (error.code !== "ERR_CANCELED") setAllUGLError(true);

  //                   setExportmenu(false);
  //                 },
  //               });
  //             }}
  //           >
  //             <div className="listitem_icon excel"></div> Export All in Excel
  //           </li>
  //           <li
  //             onClick={() => {
  //               exportExcelClick(isFolio);
  //               setExportmenu(false);
  //             }}
  //           >
  //             <div className="listitem_icon excel"></div> Export to Excel
  //           </li>
  //           <li onClick={getUnrealGLPDFReport}>
  //             <div className="listitem_icon pdf"></div> Export to PDF
  //           </li>
  //         </ul>
  //         {downloadPdf.isFetching && (
  //           <div className="popup_downloader">
  //             <img src={loaderGIF} alt="img" />
  //           </div>
  //         )}

  //         {allUGLStatus.isPending && (
  //           <div className="popup_downloaderAll">
  //             <img src={loaderGIF} alt="img" />
  //           </div>
  //         )}
  //       </div>
  //       <div></div>
  //     </>
  //   );
  // };

  const accordionTableHeaderData = [
    {
      title: "Instrument Name",
      key: "instrumentName",
      sortable: true,
      renderer: accordionHeaderRender,
      className: "unitFont",
      type: "text",
      // width: "28.5%",
    },
    {
      title: "Inv Value",
      sortable: true,
      key: "investmentValue",
      renderer: accordionHeaderRender,
      className: "font-roboto",
      type: "number",
      // width: "15%",
    },
    {
      title: "Current Value",
      sortable: true,
      key: "currentValue",
      renderer: accordionHeaderRender,
      className: "font-roboto",
      type: "number",
      // width: "14%",
    },
    {
      title: "Unrealised G/L",
      sortable: true,
      key: "unrealised_GL",
      renderer: accordionHeaderRender,
      className: "font-roboto",
      type: "number",
      // width: "21%",
    },
    // {
    //   title: "Quantity",
    //   sortable: true,
    //   key: "quantityPurchased",
    //   width: "10%",
    // },
    {
      title: "Action",
      sortable: false,
      // width: "5%",
      type: "button",
      renderer: accordionHeaderRender,
    },
  ];

  const handleFilter = (filterType, sortingInAscending) => {
    const numbersKeysToSort = {
      currentValue: true,
      investmentValue: true,
      unrealised_GL: true,
    };

    let changedData = [];
    let rowData = [];
    setFilteredColumn(filterType);

    const filterData = ({ filterType, sortingInAscending }) => {
      if (filterType === filteredColumn) {
        setIsAscendingForHeader(sortingInAscending);
        changedData = rowData.reverse();
      } else {
        setIsAscendingForHeader(sortingInAscending);

        if (filterType === "instrumentName") {
          let sortedData = [...rowData]?.sort((a, b) =>
            b?.[filterType].localeCompare(a?.[filterType]),
          );
          changedData = !sortingInAscending ? sortedData : sortedData.reverse();
        } else if (numbersKeysToSort[filterType]) {
          let sortedData = [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filterType]).toFixed(2) -
              Number(b?.[filterType]).toFixed(2),
          );
          changedData = sortingInAscending ? sortedData : sortedData.reverse();
        } else changedData = rowData;
      }
    };

    rowData = folioData;
    filterData({ filterType, sortingInAscending });
    setFolioData(changedData);
  };

  const memberMenuTitle = () => {
    return typeof selectedMember !== "object" ? (
      selectedMember ? (
        selectedMember
      ) : (
        "Loading..."
      )
    ) : (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {getDefaultImageOrImage({
          clientName: selectedMember.full_name,
          imgStyle: { width: "22px", borderRadius: "9px", height: "22px" },
          imageSrc:
            getDecodedToken()?.user_type !== "manager"
              ? UserStore.currentFamilyMembersImages?.[selectedMember.user_id]
              : UserStore.userData.profile_pic
                ? UserStore.singleUsersUrl
                : "",
          defaultStyle: {
            width: "22px",
            borderRadius: "9px",
            height: "22px",
            boxSizing: "border-box",
          },
        })}
        <p>{selectedMember.full_name}</p>
      </div>
    );
  };

  const handleAccordion = (accoridonName, index) => {
    setOpenAccordions({ ...openAccordions, [accoridonName]: true });
    if (openAccordions[accoridonName])
      setOpenAccordions({ ...openAccordions, [accoridonName]: false });
    let arr = [...sortKeys];
    arr[index].key = "currentValue";
    arr[index].isAsc = false;
    setSortKeys([...arr]);
  };

  useEffect(() => {
    ReportsStore.updateTableDataLoader(true);
    trackEventWithScreen({ eventName: REPORTS_PAGE, screenName: UNREALISED });
    logEvents(REPORTS_PAGE, { screenName: UNREALISED });
    return () => {
      ReportsStore.updateUnrealisedRowData([]);
      ReportsStore.updateAllAccountToDefault();
    };
  }, []);

  useEffect(() => {
    setIsFilterClicked(true);
  }, []);

  const dataKey = {
    buyPrice: true,
    quantityPurchased: true,
    daysHeld: true,
    currentPrice: true,
    investmentValue: true,
    currentValue: true,
    unrealised_GL: true,
  };

  const investedValueCellRenderer = (data, key) => {
    if (key === "instrumentName") {
      return (
        <>
          <OverflowingText text={data[key]} width={100} />
          {}
        </>
      );
    }
    if (key === "investmentDate") {
      return (
        <>
          {true ? (
            <p className="invested_value_cell">
              {getDisplayDate2(data[key]) || "-"}
            </p>
          ) : (
            <p className="invested_value_cell font-roboto">
              {data["annualizedReturnPer"]}%
            </p>
          )}
        </>
      );
    }
    if (key === "annualizedReturnPer")
      return <p className="invested_value_cell font-roboto">{data[key]}%</p>;
    if (dataKey[key]) {
      return (
        <p className="invested_value_cell font-roboto">
          {commaSeperated(data[key])}
        </p>
      );
    }

    return (
      <p
        className={`invested_value_cell ${
          isNaN(data[key]) ? "" : "font-roboto"
        }`}
      >
        {isNaN(data[key]) ? data[key] : lakhAmt(data[key])}
      </p>
    );
  };

  const columns = [
    {
      label: "Instrument Name",
      key: "instrumentName",
      cellRenderer: investedValueCellRenderer,
      sortable: false,
      isSecondChild: true,
      // width: "100px",
    },
    {
      label: "Inv Date",
      key: "investmentDate",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data) => data,
    },
    {
      label: "Days Held",
      key: "daysHeld",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Inv Value",
      key: "investmentValue",
      sortable: true,
      isSecondChild: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Buy Price",
      key: "buyPrice",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Current Value",
      key: "currentValue",
      sortable: true,
      isSecondChild: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Current Price",
      key: "currentPrice",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Unrealised G/L",
      key: "unrealised_GL",
      sortable: true,
      isSecondChild: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Annualized Returns% ",
      key: "annualizedReturnPer",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Quantity",
      key: "quantityPurchased",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
  ];

  const columnsForExportData = [
    {
      label: "Instrument Name",
      key: "instrumentName",
      cellRenderer: investedValueCellRenderer,
      sortable: false,
    },
    {
      label: "Quantity Purchased",
      key: "quantityPurchased",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(data, false, 2) : "",
    },
    {
      label: "Inv Date",
      key: "investmentDate",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDateDMYUnGL(data, "/"),
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Days Held",
      key: "daysHeld",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(data, false, 0) : "",
    },
    {
      label: "Inv Value",
      key: "investmentValue",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(data, false, 2) : "",
    },
    {
      label: "Buy Price",
      key: "buyPrice",
      sortable: true,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(data, false, 2) : "",
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Current Value",
      key: "currentValue",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(data, false, 2) : "",
    },
    {
      label: "Current Price",
      key: "currentPrice",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(data, false, 2) : "",
    },
    {
      label: "Unrealised G/L",
      key: "unrealised_GL",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(data, false, 2) : "",
    },
    {
      label: "Annualized Returns% ",
      key: "annualizedReturnPer",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getLimitPerExcel(data, false, 2) : "",
    },
  ];

  return (
    <div>
      <PageTitle title={"Unrealised Gain Loss Report"} />
      {AuthStore.isLoadingFullScreen ||
      ReportsStore.unrealisedLoader ||
      loading ? (
        <LoadingScreen />
      ) : (
        <>
          <Header type="reports" />
          <div className="reports_outer_main">
            <div className="unrealised_gain_loss_header_container">
              <PageHeading
                headingClass="head"
                headingText="Unrealised Gain Loss"
              />
              {/* <div ref={exportUnrealRef}>
                {ulGlFilter.selectedAssetClass?.classID !== "noasset" ? (
                  <PopupMenu
                    position={{ top: "59px", right: "2px", width: "200px" }}
                    setOpen={setExportmenu}
                    open={exportMenu}
                    MenuContent={ExtractDataContent}
                  >
                    <ExtractBtn />
                  </PopupMenu>
                ) : (
                  <PopupMenu
                    position={{ top: "59px", right: "2px", width: "176px" }}
                    setOpen={() => {}}
                    open={exportMenu}
                    MenuContent={ExtractDataContent}
                  >
                    <ExtractBtn className="notClickable" />
                  </PopupMenu>
                )}
              </div> */}

              <div className="reports-export-wrapper tax-report-export-wrapper">
                <ExportReportList
                  exportAllExcel={() => {
                    if (controllerRefAll.current)
                      controllerRefAll.current.abort();
                    const controllerAll = new AbortController();
                    controllerRefAll.current = controllerAll;

                    setAllUGLStatus((prev) => ({
                      isPending: true,
                      isError: false,
                    }));
                    // fetch all records from api ( Record includes folio as well as normal instruments but are not in order )
                    ReportsStore.getUnrealisedReportAllExcel({
                      controllerAll,
                      filterData: {
                        ...allUGlFilter,
                        isInception: isInceptionData.appliedValue,
                      },
                      onSuccess: (data) => {
                        // Using available asset and sub asset class data of selected user , we get folioInstrument, nonFolioInstrument
                        // { folioInstrument , nonFolioInstrument } = data
                        // those instruments are not in order and also not in their respective group
                        // below exportMetaData contains foliodata and nonFolioData in order
                        // all the data we display , we get it from the api and from fron-end there is no calculation , only grouping is done.
                        // { folioData , nonFolioData } = getAllExportData(data)
                        const exportMetaData = getAllExportData(data);

                        printAllExcelUGL({
                          sheetName: "Unrealised Gain Loss Full Report",
                          filter: ReportsStore.unrealisedReportFilter,
                          columns: columnsForExportData,
                          exportMetaData,
                          exportDetails: UserStore.exportDetails,
                          asOfDate: UserStore.asOfDate,
                          getData: UserStore.getData,
                          userData: UserStore.userData,
                          isInceptionData,
                        });

                        setAllUGLStatus((prev) => ({
                          isPending: false,
                          isError: false,
                        }));
                        // setExportmenu(false);
                      },
                      onFail: (error) => {
                        setAllUGLStatus((prev) => ({
                          isPending: false,
                          isError: "Error Downloading the file",
                        }));
                        if (error.code !== "ERR_CANCELED") setAllUGLError(true);

                        //setExportmenu(false);
                      },
                    });
                  }}
                  exportExcel={() => {
                    const { selectedMember = null, selectedAccount = null } =
                      ReportsStore.unrealisedReportFilter;

                    const excelProps = {
                      sheetname: "Unrealised Gain Loss Report",
                      customNameWithTime: unrealisedName(
                        ReportsStore.unrealisedReportFilter.selectedMember,
                        ReportsStore.unrealisedReportFilter.selectedAccount,
                      ),
                      columns: columnsForExportData,
                      data: rowDataForExport,
                      reportDetails: {
                        relatioshipManager: UserStore?.exportDetails?.find(
                          (item) => item.role === "RM",
                        )?.name,
                        serviceManager: UserStore?.exportDetails?.find(
                          (item) => item.role === "CXO",
                        )?.name,
                        date: getPrintDate(UserStore.asOfDate),
                        clientName:
                          UserStore.getData === "fam"
                            ? UserStore.userData?.family_name
                            : UserStore.userData?.full_name,
                      },
                      excelName: getUGLFileName({
                        selectedMember,
                        selectedAccount,
                        isInceptionData,
                      }),
                    };

                    exportExcel(
                      !isFolio
                        ? excelProps
                        : {
                            ...excelProps,
                            customExcelTableStyle: ({ worksheet, data }) =>
                              unrealisedFolioExcelStyle({ worksheet, data }),
                          },
                    );
                  }}
                  exportPdf={() => {
                    if (controllerRef.current) controllerRef.current.abort();
                    const controller = new AbortController();
                    controllerRef.current = controller;

                    setDownloadPdf((prev) => ({
                      isFetching: true,
                      isError: false,
                    }));

                    const {
                      selectedMember,
                      selectedAccount,
                      selectedAssetClass,
                      selectedSubAssetClass,
                      isFolio: folio,
                    } = ulGlFilter;

                    const getOfficerName = ({ name }) => {
                      return (
                        UserStore.exportDetails?.find(
                          (item) => item.role === name,
                        )?.name || ""
                      );
                    };

                    const rmo = getOfficerName({ name: "RM" });
                    const cxo = getOfficerName({ name: "CXO" });
                    const name = unrealisedName(
                      selectedMember,
                      selectedAccount,
                    );

                    ReportsStore.getUnrealGLReport({
                      controller,
                      fileName: getUGLFileName({
                        selectedMember,
                        selectedAccount,
                        isInceptionData,
                      }),
                      params: {
                        familyCode: "",
                        clientCode: selectedMember.user_id,
                        accountCode:
                          selectedAccount === "All"
                            ? 0
                            : selectedAccount.account_Code,
                        classID: selectedAssetClass.classID,
                        subClassID: selectedSubAssetClass.classID,
                        client_Info: {
                          client_Name: name,
                          account_Name:
                            selectedAccount === "All"
                              ? "All"
                              : selectedAccount.account_Code,
                          date: getAsOfDate(UserStore.asOfDate),
                          relationship_Manager: rmo,
                          service_Manager: cxo,
                        },
                        isFolio: getFolioBooleanValue({ isFolio: folio }),
                        isInception: isInceptionData.appliedValue,
                      },
                      onSuccess: (data) => {
                        setDownloadPdf((prev) => ({
                          isFetching: false,
                          isError: false,
                        }));
                        // setExportmenu(false);
                      },
                      onFail: (err) => {
                        setDownloadPdf((prev) => ({
                          isFetching: false,
                          isError: "Error Downloading the file",
                        }));
                        if (err.code !== "ERR_CANCELED")
                          setOpenErrorModel(true);
                        // setExportmenu(false);
                      },
                    });
                  }}
                  buttonProps={{
                    buttonType: "reportExport",
                  }}
                  popupClassName={{
                    open: "clicked-hover",
                    close: "",
                    wrapperClass: "popup_menu_container",
                    containerClass: "downloadAllPdf downloadPdf",
                  }}
                  restrictHover={true}
                  itemRefs={exportItemRefs}
                  menuItems={exportDataMenuUGLReport}
                  accessibilityValues={{
                    buttonId: "export-dropdown",
                    ariaHaspopup: "menu",
                    ariaControls: "extract-menu",
                    ariaLabel: "Extract Data",
                  }}
                  isDropdownDisabled={
                    ulGlFilter.selectedAssetClass?.classID === "noasset"
                  }
                >
                  <>
                    {downloadPdf.isFetching && (
                      <div className="popup_downloader">
                        <img src={loaderGIF} alt="img" />
                      </div>
                    )}

                    {allUGLStatus.isPending && (
                      <div className="popup_downloaderAll">
                        <img src={loaderGIF} alt="img" />
                      </div>
                    )}
                  </>
                </ExportReportList>
              </div>
            </div>
            <div className="reports_yellow_container">
              <div className="dropdown_container ugl-report">
                <GoldenDropDown
                  heading={memberMenuTitle()}
                  selectedMember={selectedMember}
                  showPopup={
                    getDecodedToken()?.user_type === "manager" ||
                    (getDecodedToken()?.user_type === "employee" &&
                      UserStore?.selectedClientId !== "0") ||
                    (getDecodedToken()?.user_type === "customer" &&
                      (getDecodedToken()?.primary === "false" ||
                        UserStore?.selectedClientId !== "0"))
                      ? false
                      : true
                  }
                  popupMenuClass="reports_select_family_member_popup_menu"
                  ReportMenuContent={AllMembersMenuContent}
                  reportsMenuOpen={allMembersMenuOpen}
                  setReportsMenuOpen={setAllMembersMenuOpen}
                  position={{ top: "57px", left: "0px", minWidth: 380 }}
                  showArrow={false}
                  dropDownContainerClass="all_members_dropdown ugl-report"
                  isDisabled={!selectedMember}
                />
                <AccountsDropDown
                  heading={
                    selectedAccount1 !== "All"
                      ? selectedAccount1.account_Name
                      : "All Accounts"
                  }
                  headingValue={selectedAccount1}
                  setHeadingValue={(data) => setSelectedAccount1(data)}
                  position={unrealSubAssetDDPosition}
                  showArrow={false}
                  disabledPopup={selectedStocks?.nodata}
                  isDisabled={checkAccountsDropdownDisabled()}
                  popupClassName={{
                    wrapperClass: "popup_menu_container",
                    dropDownContainerClass: "all_accounts_dropdown ugl-report",
                    popupMenuClass: "",
                  }}
                  restrictHover={true}
                  OPTIONS={[
                    { account_Code: "All", account_Name: "All Accounts" },
                  ].concat(getAccountsList())}
                  accessibilityValues={{
                    buttonId: "",
                    ariaHaspopup: "radiogroup",
                    ariaControls: "accounts-options",
                    ariaLabel: "Accounts Type",
                  }}
                />
                <DropdownWithOptions
                  heading={
                    ReportsStore.unrealAssetClassesStatus
                      ? "Loading..."
                      : selectedInvestmentType?.className
                        ? selectedInvestmentType?.className
                        : "Loading..."
                  }
                  headingValue={selectedInvestmentType}
                  setHeadingValue={(data) => setSelectedInvestmentType(data)}
                  position={unrealSubAssetDDPosition}
                  showArrow={false}
                  disabledPopup={selectedStocks?.nodata}
                  isDisabled={
                    ReportsStore?.unrealisedReportFilter?.selectedAssetClass
                      ?.className === "No Asset Class" ||
                    !selectedInvestmentType?.className
                  }
                  popupClassName={{
                    wrapperClass: "popup_menu_container",
                    dropDownContainerClass: "all_accounts_dropdown ugl-report",
                    popupMenuClass: "",
                  }}
                  restrictHover={true}
                  OPTIONS={ReportsStore.allAssetClassesData}
                  accessibilityValues={{
                    buttonId: "",
                    ariaHaspopup: "radiogroup",
                    ariaControls: "asset-class-options",
                    ariaLabel: "Asset Class Type",
                  }}
                />
                <DropdownWithOptions
                  heading={
                    ReportsStore.unrealAssetClassesStatus
                      ? "Loading..."
                      : ReportsStore.unrealisedReportFilter
                            .selectedSubAssetClass?.className ===
                          "No Sub Asset Class"
                        ? "No Sub Asset Class"
                        : selectedStocks?.className
                          ? selectedStocks?.className
                          : "No Sub Asset Class"
                  }
                  headingValue={selectedStocks}
                  setHeadingValue={(data) => setSelectedStocks(data)}
                  position={unrealSubAssetDDPosition}
                  showArrow={false}
                  disabledPopup={selectedStocks?.nodata}
                  isDisabled={
                    ReportsStore.unrealisedReportFilter.selectedSubAssetClass
                      ?.className === "No Sub Asset Class" ||
                    !ReportsStore.subAssetFiltered?.[
                      selectedInvestmentType?.classID
                    ]?.length
                  }
                  popupClassName={{
                    wrapperClass: "popup_menu_container",
                    dropDownContainerClass: "all_accounts_dropdown ugl-report",
                    popupMenuClass: "",
                  }}
                  restrictHover={true}
                  OPTIONS={
                    ReportsStore.subAssetFiltered?.[
                      selectedInvestmentType?.classID
                    ]
                  }
                  accessibilityValues={{
                    buttonId: "",
                    ariaHaspopup: "radiogroup",
                    ariaControls: "sub-asset-class-options",
                    ariaLabel: "Sub Asset Class",
                  }}
                />
                <DateTypeDropdown
                  heading={
                    aquisitionValue[isInceptionData.value] || "Not Selected"
                  }
                  headingValue={isInceptionData}
                  setHeadingValue={(data) =>
                    setIsInceptionData((prev) => ({
                      ...prev,
                      isMenunOpen: false,
                      value: data,
                    }))
                  }
                  position={{
                    top: "56px",
                    left: "0px",
                    minWidth: "180px",
                    width: "fit-content",
                  }}
                  showArrow={false}
                  // disabledPopup={selectedStocks?.nodata}
                  // isDisabled={
                  //   ReportsStore?.unrealisedReportFilter?.selectedAssetClass
                  //     ?.className === "No Asset Class" ||
                  //   !selectedInvestmentType?.className
                  // }
                  popupClassName={{
                    wrapperClass: "popup_menu_container",
                    dropDownContainerClass: "all_accounts_dropdown ugl-report",
                    popupMenuClass: "",
                  }}
                  restrictHover={true}
                  OPTIONS={
                    UserStore.usersData !== "(Inception)"
                      ? [...trasnfArr]
                      : [...inceptionArr]
                  }
                  accessibilityValues={{
                    buttonId: "",
                    ariaHaspopup: "radiogroup",
                    ariaControls: "date-type-options",
                    ariaLabel: "Date Type",
                  }}
                />
              </div>

              <ApplyFilter
                customCss="reusable-button"
                onApplyFilter={
                  !ReportsStore.unrealAssetClassesStatus
                    ? onApplyFilter
                    : applyDummy
                }
                onClearFilter={onClearFilter}
              />
            </div>
            {ReportsStore.tableDataLoader ? (
              <div className="report_table_loader">
                <div className="report_loader_wrapper">
                  <img
                    className="loading_gif"
                    src={loaderGIF}
                    alt="loading..."
                  />
                </div>
              </div>
            ) : (
              <>
                {ReportsStore.unrealisedReportData &&
                ReportsStore.unrealisedReportData.length ? (
                  <table className="unrealised_gain_loss accordion_table">
                    <TableCaption captionName={"Unrealised Gain Loss Data"} />
                    <AccordionTableHeader
                      accordionTableHeaderData={accordionTableHeaderData}
                      handleFilter={(key, order) => {
                        handleFilter(key, order);
                      }}
                      isAscendingForHeader={isAscendingForHeader}
                      filteredColumn={filteredColumn}
                    />

                    {!isFolio ? (
                      <tbody className="accordion_table_data">
                        {folioData?.map((rowData, index) => {
                          return (
                            <>
                              <Accordion>
                                <AccordionHeader
                                  border
                                  borderRadius={
                                    openAccordions[rowData?.instrumentName]
                                  }
                                >
                                  {headerRenderer({
                                    rowData,
                                    index,
                                    openAccordions,
                                    handleAccordion,
                                  })}
                                </AccordionHeader>
                                <AccordionContent
                                  open={openAccordions[rowData?.instrumentName]}
                                >
                                  <UnrealisedTable
                                    rowData={rowData}
                                    instrumentsData={rowData.subData?.data}
                                    // data={rowData.subData}
                                    columns={columns}
                                    order={clmSortOrder.find(
                                      (data) =>
                                        data.id === rowData.instrumentID,
                                    )}
                                    setOrder={(data) => {
                                      const ordArr = clmSortOrder;
                                      const idx = ordArr.findIndex(
                                        (ordData) => ordData.id === data.id,
                                      );
                                      ordArr[idx] = data;
                                      setClmSortOrder(ordArr);
                                    }}
                                  />
                                </AccordionContent>
                              </Accordion>
                            </>
                          );
                        })}
                      </tbody>
                    ) : (
                      <tbody className="accordion_table_data">
                        {folioData?.map((rowData, index) => {
                          return (
                            <>
                              <Accordion>
                                <AccordionHeader
                                  border
                                  borderRadius={
                                    openAccordions[rowData?.instrumentName]
                                  }
                                >
                                  {headerRenderer({
                                    rowData,
                                    index,
                                    openAccordions,
                                    handleAccordion,
                                  })}
                                </AccordionHeader>
                                <AccordionContent
                                  open={openAccordions[rowData?.instrumentName]}
                                >
                                  <UnrealisedFolioTable
                                    rowData={rowData}
                                    data={rowData.subData}
                                    columns={columns}
                                    order={clmSortOrder.find(
                                      (data) =>
                                        data.id === rowData.instrumentID,
                                    )}
                                    setOrder={(data) => {
                                      const ordArr = clmSortOrder;
                                      const idx = ordArr.findIndex(
                                        (ordData) => ordData.id === data.id,
                                      );
                                      ordArr[idx] = data;
                                      setClmSortOrder(ordArr);
                                    }}
                                  />
                                </AccordionContent>
                              </Accordion>
                            </>
                          );
                        })}
                      </tbody>
                    )}
                  </table>
                ) : (
                  <div className="empty_state_for_valuation">
                    <EmptyDerivatives
                      image={nodataImage}
                      message="You do not have any records to display"
                    />
                  </div>
                )}{" "}
              </>
            )}
          </div>
        </>
      )}
      {/* Modal for displying error 
      1. Common Error
      2. Error while downloading PDF */}
      <Modal
        modalStyle={{
          padding: "25px 25px 33px",
        }}
        showCloseIcon={true}
        open={openErrorModel}
        onClose={() => {
          setOpenErrorModel(false);
          setDownloadPdf((prev) => ({ isFetching: false, isError: false }));
          setErrorMsg("");
        }}
      >
        <ShowErrorModal
          msg={errorMsg || somethingWrongErr}
          onConfirm={() => {
            setOpenErrorModel(false);
            setDownloadPdf((prev) => ({ isFetching: false, isError: false }));
            setErrorMsg("");
          }}
        />
      </Modal>
      {/* Modal For displaying error occuring in All excel report */}

      <Modal
        modalStyle={{
          padding: "25px 25px 33px",
        }}
        showCloseIcon={true}
        open={allUGLError}
        onClose={() => {
          setAllUGLError(false);
          setAllUGLStatus((prev) => ({ isPending: false, isError: false }));
        }}
      >
        <AllErrorModalUGL
          msg={somethingWrongErrAll}
          onConfirm={() => setAllUGLError(false)}
        />
      </Modal>
    </div>
  );
});

export default UnrealisedGainLossReport;
